
























































import { useFilters } from '@/app/composable';
import { CloudUploadIcon, DocumentIcon, DocumentSearchIcon } from '@vue-hero-icons/outline';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

export default defineComponent({
    name: 'FileDropTarget',
    components: { CloudUploadIcon, DocumentIcon, DocumentSearchIcon },
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        disabledLabel: {
            type: String,
            required: false,
        },
        hint: {
            type: String,
            required: false,
        },
        accept: {
            type: String,
            required: false,
        },
        icon: {
            type: String as PropType<'search' | 'upload'>,
            default: 'upload',
        },
        file: {
            type: [Object, File] as PropType<{ name?: string; filename?: string; size?: number } | File | null>,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        dataTestid: {
            type: String,
            required: false,
        },
    },
    setup(props, { emit }) {
        const { formatBytes } = useFilters();
        const inputRef = ref<HTMLInputElement | null>(null);
        const dragging = ref<boolean>(false);

        const filename = computed(() => {
            const file = props.file as any;
            return file?.name ?? file?.filename;
        });

        const iconClass = computed(() => {
            if (props.invalid) return 'text-red-500';
            return props.disabled || props.loading ? 'text-neutral-400' : 'text-primary-500';
        });

        const select = (file?: File) => {
            if (!file || props.disabled || props.loading) return;
            emit('file-selected', file);
            // allows re-selecting the same file right after
            if (inputRef.value) inputRef.value.value = '';
        };

        const onDragOver = () => {
            if (props.disabled || props.loading) return;
            dragging.value = true;
        };

        const onDrop = (event: DragEvent) => {
            dragging.value = false;
            select(event.dataTransfer?.files[0]);
        };

        const onChange = (event: any) => select(event.target.files[0]);

        return { dragging, filename, formatBytes, iconClass, inputRef, onChange, onDragOver, onDrop };
    },
});
